export default __webpack_public_path__ + "static/media/Background_00264.b9c5e80a.png";